import Grid from '@mui/material/Unstable_Grid2/Grid2'
import OneSelect from '../../../../Components/OneSelect/OneSelect'
import { Tooltip } from '@mui/material'
import OneButton from '../../../../Components/OneButton/OneButton'
import { useContext, useEffect, useState } from 'react'
import { VisitantesContext } from '../../../../Providers/VisitantesContext/VisitantesContext'
import ObsLibTempModal from './ObsLibTempModal/ObsLibTempModal'
import { empty } from '../../../../Utils/Utils'
import OneCheckbox from '../../../../Components/OneCheckbox/OneCheckbox'

const LiberarAcessoVisitante = ({ modifyDisabled, height }) => {
    const {
        activeCond,
        liberarAcessoTemp,
        moradoresSelecionados,
        visitantesSelecionados,
        liberarAcessoFuturo,
        sincronizarFaciais,
        autorizarVisitanteNotificarMorador
        // liberarTagsFaciais
    } = useContext(VisitantesContext)
    const [tempoLiberacao, setTempoLiberacao] = useState(0)
    // const [liberarFacial, setLiberarFacial] = useState(true) // temporário para a 'Minha Portaria'
    const [liberarFacial, setLiberarFacial] = useState(false)
    const [notificarApp, setNotificarApp] = useState(false)
    const [optionsGrupoAcesso, setOptionsGrupoAcesso] = useState([])
    const [grupoAcessoSelecionado, setGrupoAcessoSelecionado] = useState(false)

    const opcoesLiberarTemporariamente = [
        { id: 0, descricao: 'Tempo de Liberação' },
        { id: 's1', descricao: 'Liberar até a saída' },
        { id: 'm5', descricao: 'Liberar 5 minutos' },
        { id: 'm15', descricao: 'Liberar 15 minutos' },
        { id: 'm30', descricao: 'Liberar 30 minutos' },
        { id: 'h1', descricao: 'Liberar 1 hora' },
        { id: 'h3', descricao: 'Liberar 3 horas' },
        { id: 'h8', descricao: 'Liberar 8 horas' },
        { id: 'd1', descricao: 'Liberar 1 dia' },
        { id: 'd3', descricao: 'Liberar 3 dias' },
        { id: 'd7', descricao: 'Liberar 1 semana' }
    ]

    useEffect(() => {
        if (autorizarVisitanteNotificarMorador !== null) {
            setNotificarApp(autorizarVisitanteNotificarMorador)
        } else {
            if (activeCond?.notifica_morador_visitante !== undefined) {
                setNotificarApp(activeCond.notifica_morador_visitante)
            }
        }
        if (activeCond?.liberacao_padrao_visitante !== undefined && activeCond.liberacao_padrao_visitante !== null) {
            setTempoLiberacao(activeCond.liberacao_padrao_visitante)
        }
    }, [autorizarVisitanteNotificarMorador, activeCond])

    useEffect(() => {
        if (visitantesSelecionados?.length > 0) {
            const tagsVisitantes = visitantesSelecionados.filter(({ tag }) => tag && !['', '0', 'null', 'undefined'].includes(tag))
            if (tagsVisitantes.length === 0) {
                setOptionsGrupoAcesso([])
            } else if (activeCond?.grupos_acesso) {
                const gruposVisitante = activeCond.grupos_acesso.filter(({ app_convidado }) =>
                    app_convidado === true
                )
                setOptionsGrupoAcesso(gruposVisitante)
            }
        } else {
            setOptionsGrupoAcesso([])
        }
    }, [activeCond, visitantesSelecionados])

    const [openObsLibTemp, setOpenObsLibTemp] = useState(false)

    const handleLiberarAcesso = async () => {
        let opcoesLiberacao = {
            tempoLiberacao: opcoesLiberarTemporariamente.find(op => op.id === tempoLiberacao)?.descricao,
            liberarFacial,
            notificarApp,
            grupoAcessoSelecionado: optionsGrupoAcesso.find(op => op.id === grupoAcessoSelecionado)?.descricao
        }
        liberarAcessoFuturo(tempoLiberacao, liberarFacial, notificarApp, grupoAcessoSelecionado, opcoesLiberacao) // Insere na one_historico_acesso
        modifyDisabled(false)
        if (tempoLiberacao !== 0) {
            if (!activeCond.obs_liberacao_temporaria) {
                liberarAcessoTemp(tempoLiberacao)
            } else {
                setOpenObsLibTemp(true)
            }
        } else {
            if (!empty(liberarFacial)) { liberarAcessoTemp('sempre') }
        }

        if (!empty(liberarFacial)) { sincronizarFaciais() }
    }

    return (
        <>
            <Grid container sx={{ height, alignContent: 'center', justifyContent: 'center' }} xs={12}>
                {openObsLibTemp &&
            <ObsLibTempModal
                openObsLibTemp={openObsLibTemp}
                setOpenObsLibTemp={setOpenObsLibTemp}
                tempoLiberacao={tempoLiberacao}
            />
                }
                <Grid xs item>
                    { (tempoLiberacao == 0 || tempoLiberacao != '') &&
                        <OneSelect
                            key={tempoLiberacao}
                            placeholder="Liberar acesso até"
                            // defaultValue={0}
                            defaultValue={tempoLiberacao}
                            options={opcoesLiberarTemporariamente}
                            onChange={(e) => {
                                setTempoLiberacao(e.target.value)
                            }}
                        />
                    }
                </Grid>
                <Grid xs item sx={{ padding: '0 4px' }}>
                    {optionsGrupoAcesso.length > 0 &&
                    <Tooltip title="Apenas para os visitantes com a tag facial" placement="top" arrow>
                        <OneSelect
                            placeholder="Grupos de Acesso"
                            options={optionsGrupoAcesso}
                            onChange={(e) => {
                                setGrupoAcessoSelecionado(e.target.value)
                            }}
                        />
                    </Tooltip>
                    }
                </Grid>
                <Grid container xs={2} sx={{ alignContent: 'center', justifyContent: 'center' }}>
                    <OneCheckbox
                        checked={liberarFacial}
                        onChange={() => {
                            setLiberarFacial(!liberarFacial)
                        }}
                        text="Liberar Facial"
                        colorBox="black"
                        colorLabel="black"
                        labelSize="13px"
                    />
                </Grid>
                <Grid container xs={2} sx={{ alignContent: 'center' }}>
                    <OneCheckbox
                        checked={notificarApp}
                        onChange={() => {
                            setNotificarApp(!notificarApp)
                        }}
                        text="Notificar Morador"
                        colorBox="black"
                        colorLabel="black"
                        labelSize="13px"
                    />
                </Grid>
                <Tooltip title={tempoLiberacao === 0 ? "Selecione visitante e morador!" : "Liberar visitantes selecionados!"}>
                    <Grid container xs={2} sx={{ alignContent: 'center' }}>
                        <OneButton
                            id="button"
                            backgroundColor="#0FBB00"
                            variant="contained"
                            size={screen.width > 1440 ? 'medium' : 'small'}
                            onClick={() => {
                                handleLiberarAcesso()
                            }}
                            disabled={!((visitantesSelecionados && visitantesSelecionados.length > 0) &&
                            (moradoresSelecionados && moradoresSelecionados.length > 0))
                            }
                            modifyDisabled={modifyDisabled}
                            newSx={{ fontSize: '10px', fontWeight: 'bold' }}
                        >
                    Liberar Acessos
                        </OneButton>
                    </Grid>
                </Tooltip>
            </Grid>
        </>
    )
}

export default LiberarAcessoVisitante
